import Error from '../../../model/Error';
import Team from '../../../dto/Team';
import axios from 'axios';

export default class OfferingTeamRepository {
    static findAll(clubId, withoutFilter) {
        return new Promise((resolve, reject) => {
            let url = `/club/clubs/${clubId}/offerings/teams`;
            if (withoutFilter) {
                url = `${url}?showAll=1`;
            }
            axios
                .get(url)
                .then((response) => resolve(response.data.data.map((data) => Team.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
